import { StepVariables } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

import { createUserId } from "../../utils";
import * as ToolsStepTracker from "../toolStep.tracker";
import { TOOL_CONTACT_CONTEXT, TOOL_CONTACT_STEPS } from "./config";

export const trackStart = () => {
    ToolsStepTracker.track(TOOL_CONTACT_STEPS.start, TOOL_CONTACT_CONTEXT);
};

export const trackSubmit = (contactResult: any) => {
    if (!contactResult) return;

    const customerid = createUserId(contactResult.email);
    const step: StepVariables = {
        ...TOOL_CONTACT_STEPS.submit,
        result: {
            customerid: customerid,
            storeId: contactResult.storeId,
            rubriek: contactResult.rubriek
        }
    };

    ToolsStepTracker.trackSubmit(step, TOOL_CONTACT_CONTEXT);
};
